import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncateText' })
export class TruncateTextPipe implements PipeTransform {
	public transform(text: string | number, length: number): string {
		text = typeof text === 'number' ? text.toString() : text;
		if (!text) {
			return text;
		}

		return text.length < length ? text : `${text.substring(0, length)}...`;
	}
}
